import { useState, useEffect, useCallback } from 'react';
import { usePathname } from 'next/navigation';
import { useBodyOverflow } from './use-body-overflow';

/**
 * Hook to manage mobile menu state and behavior
 *
 * Features:
 * - Manages open/closed state
 * - Closes menu on navigation
 * - Locks body scroll when menu is open
 * - Provides toggle and close handlers
 *
 * @returns Object with menu state and control functions
 */
export function useMobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  // Lock body scroll when menu is open
  useBodyOverflow(isOpen);

  // Close menu on navigation
  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    toggle,
    close,
  };
}
